module.exports = __webpack_public_path__ + "media/images/partner/media/rtl-3e037a9510ef35da473a250fc2b48d55.png";